import React from 'react';
import classNames from 'classnames/bind';
import styles from './TranslateGuide.module.scss';

const cx = classNames.bind(styles);

function TranslateGuide() {
	return (
		<div className={cx('wrap')}>
			<p className={cx('desc')}>
				This report is currently in Korean.
				<br />
				You can view it in English by using your mobile browsers&apos; translation menu.
			</p>
			<div className={cx('guide_list')}>
				{/* Android (Chrome) */}
				<div className={cx('guide_item')}>
					<div className={cx('guide_title')}>
						<span className={cx('ico_android')} />
						<span className={cx('title_txt')}>Android (Chrome)</span>
					</div>
					<ul className={cx('step_list')}>
						<li>
							<span className={cx('num')}>1.</span>
							<span className={cx('txt')}>Tap the three dots ( ⋮ ) at the top right corner.</span>
						</li>
						<li>
							<span className={cx('num')}>2.</span>
							<span className={cx('txt')}>Select &apos;Translate...&apos; from the menu.</span>
						</li>
					</ul>
				</div>
				{/* iPhone (Safari) */}
				<div className={cx('guide_item')}>
					<div className={cx('guide_title')}>
						<span className={cx('ico_apple')} />
						<span className={cx('title_txt')}>iPhone (Safari)</span>
					</div>
					<ul className={cx('step_list')}>
						<li>
							<span className={cx('num')}>1.</span>
							<span className={cx('txt')}>Tap the &apos;AA&apos; or menu icon ( ☰ ) in the address bar.</span>
						</li>
						<li>
							<span className={cx('num')}>2.</span>
							<span className={cx('txt')}>
								Select &apos;Translate to English&apos;
								<br />
								(or your language).
							</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
}

export default TranslateGuide;
